export default {
    locale: "ru",
};
